var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "#151B26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.46633 11.3384H4.05265C3.58136 11.3384 3.19922 11.7205 3.19922 12.1918V25.8463C3.19922 26.3176 3.5813 26.6997 4.05265 26.6997H7.46627C7.93756 26.6997 8.31971 26.3176 8.31971 25.8463V12.1918C8.31971 11.7205 7.93768 11.3384 7.46633 11.3384Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7834 13.6C28.6329 12.2761 27.3962 11.3378 26.0638 11.3378H19.4104C19.9758 10.3253 20.2793 7.46165 20.2659 6.29183C20.2435 4.35545 18.64 2.80371 16.7035 2.80371H15.9993C15.5276 2.80371 15.1459 3.1854 15.1459 3.65714C15.1459 5.6306 14.3774 9.19265 12.9282 10.642C11.9527 11.6174 11.1188 11.9709 10.0254 12.5174V25.3227C11.6995 25.8807 13.8251 26.6992 17.0649 26.6992H22.6475C24.4869 26.6992 25.9195 24.9956 25.2067 23.1956C26.2927 22.8998 27.0936 21.9038 27.0936 20.7254C27.0936 20.3928 27.0294 20.0745 26.9136 19.7819C28.7436 19.2833 29.4172 17.0237 28.147 15.6049C28.6137 15.0836 28.871 14.3705 28.7834 13.6Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default ForwardRef;